import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import CTA from '../home/components/CTA';
import Breadcrumb from '../../components/Breadcrumb';
import { useEffect, useState } from 'react';

export default function ResidentialPage() {
  const [activeTab, setActiveTab] = useState(0);

  useEffect(() => {
    // Page title
    document.title = 'Residential Insulation Yuma AZ | Home Energy Savings';

    // Meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute(
        'content',
        'Professional residential spray foam insulation. Cut cooling costs 50% with attic, wall, crawl space & garage services. Licensed Arizona contractors. Free quotes. Call (928) 427-8140.'
      );
    }

    // Keywords meta tag - OPTIMIZED with variations
    let metaKeywords = document.querySelector('meta[name="keywords"]');
    if (!metaKeywords) {
      metaKeywords = document.createElement('meta');
      metaKeywords.setAttribute('name', 'keywords');
      document.head.appendChild(metaKeywords);
    }
    metaKeywords.setAttribute('content', 'spray foam insulation Yuma AZ, residential insulation Arizona, home insulation contractors, attic insulation services, wall insulation Yuma, crawl space sealing Arizona, garage insulation, energy efficient homes');

    // Canonical URL
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', window.location.origin + '/residential');

    // Open Graph tags - ENHANCED
    const ogTags = [
      { property: 'og:title', content: 'Residential Spray Foam Insulation Yuma AZ | Home Energy Savings' },
      {
        property: 'og:description',
        content:
          'Expert residential spray foam insulation in Yuma, AZ. Cut cooling costs up to 50%. Professional attic, wall, crawl space & garage insulation. Free quotes available.'
      },
      { property: 'og:type', content: 'website' },
      { property: 'og:url', content: window.location.origin + '/residential' },
      {
        property: 'og:image',
        content:
          'https://public.readdy.ai/ai/img_res/04cc3e4ead67bac5ee879b5cf2dbaeb6.jpg'
      }
    ];
    ogTags.forEach(tag => {
      let el = document.querySelector(`meta[property="${tag.property}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute('property', tag.property);
        document.head.appendChild(el);
      }
      el.setAttribute('content', tag.content);
    });

    // Twitter Card tags
    const twitterTags = [
      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:title', content: 'Residential Spray Foam Insulation Yuma AZ | Home Energy Savings' },
      {
        name: 'twitter:description',
        content:
          'Expert residential spray foam insulation in Yuma, AZ. Reduce cooling costs up to 50%. Free quotes. Call (928) 427-8140.'
      },
      {
        name: 'twitter:image',
        content:
          'https://readdy.ai/api/search-image?query=Modern%20residential%20home%20Arizona%20with%20professional%20spray%20foam%20insulation%2C%20bright%20interior%2C%20energy%20efficiency%2C%20comfortable%20desert%20living%2C%20simple%20clean%20background&width=1200&height=630&seq=twitter-residential-002&orientation=landscape'
      }
    ];
    twitterTags.forEach(tag => {
      let el = document.querySelector(`meta[name="${tag.name}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute('name', tag.name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', tag.content);
    });

    // Last-modified tag
    let lastModified = document.querySelector('meta[name="last-modified"]');
    if (!lastModified) {
      lastModified = document.createElement('meta');
      lastModified.setAttribute('name', 'last-modified');
      document.head.appendChild(lastModified);
    }
    lastModified.setAttribute('content', new Date().toISOString().split('T')[0]);

    // Breadcrumb Schema - NEW
    const breadcrumbSchema = {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          name: 'Home',
          item: window.location.origin
        },
        {
          '@type': 'ListItem',
          position: 2,
          name: 'Residential Insulation',
          item: window.location.origin + '/residential'
        }
      ]
    };
    let breadcrumbScript = document.querySelector('script[data-schema="breadcrumb-residential"]');
    if (!breadcrumbScript) {
      breadcrumbScript = document.createElement('script');
      breadcrumbScript.setAttribute('type', 'application/ld+json');
      breadcrumbScript.setAttribute('data-schema', 'breadcrumb-residential');
      document.head.appendChild(breadcrumbScript);
    }
    breadcrumbScript.textContent = JSON.stringify(breadcrumbSchema);

    // Service Schema - OPTIMIZED
    const serviceSchema = {
      '@context': 'https://schema.org',
      '@type': 'Service',
      serviceType: 'Residential Spray Foam Insulation',
      provider: {
        '@type': 'LocalBusiness',
        name: 'Yuma Spray Foam Pros',
        telephone: '(928) 427-8140',
        address: {
          '@type': 'PostalAddress',
          addressLocality: 'Yuma',
          addressRegion: 'AZ',
          postalCode: '85364',
          addressCountry: 'US'
        }
      },
      areaServed: {
        '@type': 'City',
        name: 'Yuma',
        containedIn: {
          '@type': 'State',
          name: 'Arizona'
        }
      },
      hasOfferCatalog: {
        '@type': 'OfferCatalog',
        name: 'Residential Insulation Services',
        itemListElement: [
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'Attic Insulation',
              description: 'Professional attic spray foam insulation to reduce cooling costs up to 50% in Arizona desert climate'
            }
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'Wall Insulation',
              description: 'Superior wall insulation for new construction and retrofit projects throughout Arizona'
            }
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'Crawl Space Sealing',
              description: 'Complete crawl space encapsulation and moisture protection for Arizona homes'
            }
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'Garage Insulation',
              description: 'Garage conversion and temperature control solutions for comfortable living spaces'
            }
          }
        ]
      }
    };
    let serviceScript = document.querySelector('script[data-schema="service-residential"]');
    if (!serviceScript) {
      serviceScript = document.createElement('script');
      serviceScript.setAttribute('type', 'application/ld+json');
      serviceScript.setAttribute('data-schema', 'service-residential');
      document.head.appendChild(serviceScript);
    }
    serviceScript.textContent = JSON.stringify(serviceSchema);

    // FAQ Schema - OPTIMIZED with natural language
    const faqSchema = {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: [
        {
          '@type': 'Question',
          name: 'How much can I save on energy bills with spray foam insulation?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Homeowners in Arizona typically reduce cooling costs by up to 50% with professional spray foam insulation. Most see immediate savings on monthly utility bills due to superior thermal protection in extreme desert heat.'
          }
        },
        {
          '@type': 'Question',
          name: 'How long does residential insulation installation take?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Most residential spray foam insulation projects are completed in 1-2 days with minimal disruption to your daily routine. Our certified team works efficiently to get you back to normal quickly.'
          }
        },
        {
          '@type': 'Question',
          name: 'What areas of my home can be insulated with spray foam?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'We provide comprehensive spray foam insulation for attics, walls, crawl spaces, and garages. Each area receives custom treatment for optimal energy efficiency and comfort in your home.'
          }
        },
        {
          '@type': 'Question',
          name: 'Does spray foam insulation increase home value?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Yes, energy-efficient homes with professional spray foam insulation sell faster and for more money in the Arizona market. It is a smart investment that improves comfort, reduces energy costs, and increases property value.'
          }
        }
      ]
    };
    let faqScript = document.querySelector('script[data-schema="faq-residential"]');
    if (!faqScript) {
      faqScript = document.createElement('script');
      faqScript.setAttribute('type', 'application/ld+json');
      faqScript.setAttribute('data-schema', 'faq-residential');
      document.head.appendChild(faqScript);
    }
    faqScript.textContent = JSON.stringify(faqSchema);

    // LocalBusiness schema - ENHANCED
    const businessSchema = {
      '@context': 'https://schema.org',
      '@type': 'LocalBusiness',
      name: 'Yuma Spray Foam Pros',
      telephone: '(928) 427-8140',
      geo: {
        '@type': 'GeoCoordinates',
        latitude: 32.6927,
        longitude: -114.6277
      },
      openingHoursSpecification: [
        {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
          opens: '08:00',
          closes: '17:00'
        },
        {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: 'Saturday',
          opens: '09:00',
          closes: '14:00'
        }
      ],
      aggregateRating: {
        '@type': 'AggregateRating',
        ratingValue: '5',
        reviewCount: '127'
      },
      areaServed: {
        '@type': 'City',
        name: 'Yuma',
        containedIn: {
          '@type': 'State',
          name: 'Arizona'
        }
      }
    };
    let businessScript = document.querySelector('script[data-schema="business-residential"]');
    if (!businessScript) {
      businessScript = document.createElement('script');
      businessScript.setAttribute('type', 'application/ld+json');
      businessScript.setAttribute('data-schema', 'business-residential');
      document.head.appendChild(businessScript);
    }
    businessScript.textContent = JSON.stringify(businessSchema);
  }, []);

  const residentialServices = [
    {
      title: "Attic Insulation",
      icon: "ri-home-8-line",
      description: "Prevent heat gain and reduce cooling costs by up to 50% in Arizona's extreme desert heat. Complete attic coverage using professional spray foam delivers superior thermal protection for your home.",
      image: "https://static.readdy.ai/image/cd984ab7ba08a0f8b6f75adc7751930e/c9238f7676fdc1ad6e233e1ccaa36ed4.jpeg"
    },
    {
      title: "Wall Insulation",
      icon: "ri-layout-masonry-line",
      description: "Superior thermal protection and soundproofing for homes with new construction and retrofit wall insulation projects. Advanced spray foam technology provides lasting comfort and energy efficiency.",
      image: "https://static.readdy.ai/image/cd984ab7ba08a0f8b6f75adc7751930e/0af958157b359a3ac52977c66444cf5b.jpeg"
    },
    {
      title: "Crawl Space Sealing",
      icon: "ri-building-2-line",
      description: "Protect your home foundation from moisture, mold, and energy loss with complete crawl space encapsulation. Professional sealing services ensure long-term protection and improved indoor air quality.",
      image: "https://static.readdy.ai/image/cd984ab7ba08a0f8b6f75adc7751930e/94bbd696513978aab0c6c2a15252b6d2.jpeg"
    },
    {
      title: "Garage Conversion",
      icon: "ri-car-line",
      description: "Transform your garage into a comfortable, temperature-controlled living or workspace. Professional spray foam insulation installation creates usable space year-round in the Arizona climate.",
      image: "https://static.readdy.ai/image/cd984ab7ba08a0f8b6f75adc7751930e/bb39c1a77ef8efc4e23dc892af8d7681.jpeg"
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Breadcrumb
        items={[
          { label: 'Home', href: '/' },
          { label: 'Residential' }
        ]}
      />

      {/* H1 Hero Section */}
      <header className="bg-gradient-to-br from-blue-50 to-white py-16 pt-32">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
            <strong>Residential Spray Foam Insulation</strong> in Yuma, AZ
          </h1>
          <p className="text-xl text-gray-700 max-w-4xl mx-auto leading-relaxed">
            Expert <strong>home insulation services</strong> throughout Arizona. Reduce <a href="/insulation-services-arizona" className="text-blue-900 hover:text-blue-800 font-semibold underline">cooling costs</a> up to <strong>50%</strong> with professional <strong>attic insulation</strong>, <strong>wall insulation</strong>, <strong>crawl space sealing</strong>, and <strong>garage insulation</strong>. Licensed, insured contractors serving homeowners since 2001.
          </p>
          <div className="mt-8 flex flex-wrap gap-4 justify-center">
            <a 
              href="tel:928-427-8140" 
              className="inline-block bg-emerald-600 text-white px-8 py-4 rounded-lg font-semibold hover:bg-emerald-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-line mr-2"></i>
              Call (928) 427-8140 for Free Quote
            </a>
            <a 
              href="/yuma-projects" 
              className="inline-block bg-white text-blue-900 border-2 border-blue-900 px-8 py-4 rounded-lg font-semibold hover:bg-blue-50 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-image-line mr-2"></i>
              View Our Projects
            </a>
          </div>
        </div>
      </header>

      {/* Residential Services Tabs */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              <strong>Residential Insulation Solutions</strong> for Arizona Homes
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Comprehensive <a href="/closed-cell-spray-foam" className="text-blue-900 hover:text-blue-800 font-semibold underline">spray foam insulation coverage</a> for every area of your home, from attic to foundation. Professional installation with guaranteed results.
            </p>
          </div>

          {/* Service Tabs */}
          <div className="flex justify-center gap-3 mb-8 flex-wrap">
            {residentialServices.map((service, index) => (
              <button
                key={index}
                onClick={() => setActiveTab(index)}
                className={`px-4 py-2 rounded-full text-sm font-semibold transition-all whitespace-nowrap cursor-pointer ${
                  activeTab === index
                    ? 'bg-blue-900 text-white'
                    : 'bg-white text-gray-600 hover:bg-gray-100'
                }`}
              >
                <i className={`${service.icon} mr-2`}></i>
                {service.title}
              </button>
            ))}
          </div>

          {/* Active Service Display */}
          <div className="bg-white rounded-2xl overflow-hidden shadow-lg">
            <div className="grid md:grid-cols-2 gap-0">
              <div className="relative h-96 w-full">
                <img 
                  src={residentialServices[activeTab].image}
                  alt={`Professional ${residentialServices[activeTab].title} services - spray foam installation for Arizona homes`}
                  title={`Professional ${residentialServices[activeTab].title} - Expert Installation`}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="p-10 flex flex-col justify-center">
                <div className="inline-block bg-blue-100 text-blue-900 px-4 py-2 rounded-full text-sm font-semibold mb-6 w-fit">
                  <i className={`${residentialServices[activeTab].icon} mr-2`}></i>
                  {residentialServices[activeTab].title.toUpperCase()}
                </div>
                <h3 className="text-3xl font-bold text-gray-900 mb-4">
                  <strong>{residentialServices[activeTab].title}</strong> Services
                </h3>
                <p className="text-gray-600 mb-6 leading-relaxed text-lg">
                  {residentialServices[activeTab].description}
                </p>
                <a 
                  href="tel:928-427-8140" 
                  className="inline-block bg-emerald-600 text-white px-8 py-4 rounded-lg font-semibold hover:bg-emerald-700 transition-colors whitespace-nowrap cursor-pointer text-center"
                >
                  <i className="ri-phone-line mr-2"></i>
                  Get Free Estimate Today
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Benefits Grid */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Why <strong>Homeowners</strong> Choose Our <strong>Insulation Services</strong>
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Experience the comfort and energy savings that come with <strong>professional spray foam installation</strong> in the Arizona desert climate.
            </p>
          </div>

          {/* Mobile: Horizontal Scroll */}
          <div className="md:hidden relative">
            <div className="overflow-x-auto pb-4 -mx-4 px-4 scrollbar-hide">
              <div className="flex gap-6" style={{ width: 'max-content' }}>
                <div className="bg-gray-50 p-8 rounded-xl" style={{ width: '300px', flexShrink: 0 }}>
                  <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-6">
                    <i className="ri-money-dollar-circle-line text-3xl text-blue-900"></i>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3"><strong>Lower Energy Bills</strong></h3>
                  <p className="text-gray-600 leading-relaxed">
                    Reduce <strong>cooling costs by up to 50%</strong> in extreme desert heat. Most homeowners see immediate savings on their monthly utility bills with professional <strong>spray foam insulation</strong>.
                  </p>
                </div>

                <div className="bg-gray-50 p-8 rounded-xl" style={{ width: '300px', flexShrink: 0 }}>
                  <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-6">
                    <i className="ri-temp-cold-line text-3xl text-blue-900"></i>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3"><strong>Year-Round Comfort</strong></h3>
                  <p className="text-gray-600 leading-relaxed">
                    Maintain consistent temperatures throughout your home. No more hot spots or cold drafts—just comfortable living spaces with superior <strong>thermal protection</strong> in any season.
                  </p>
                </div>

                <div className="bg-gray-50 p-8 rounded-xl" style={{ width: '300px', flexShrink: 0 }}>
                  <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-6">
                    <i className="ri-home-heart-line text-3xl text-blue-900"></i>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3"><strong>Increased Home Value</strong></h3>
                  <p className="text-gray-600 leading-relaxed">
                    <strong>Energy-efficient homes</strong> sell faster and for more money. Professional <strong>insulation installation</strong> is a smart investment that pays dividends when you sell your property.
                  </p>
                </div>

                <div className="bg-gray-50 p-8 rounded-xl" style={{ width: '300px', flexShrink: 0 }}>
                  <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-6">
                    <i className="ri-shield-check-line text-3xl text-blue-900"></i>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3"><strong>Moisture Protection</strong></h3>
                  <p className="text-gray-600 leading-relaxed">
                    Prevent mold, mildew, and water damage with our superior <strong>moisture barrier</strong>. Protect your family's health and your home's structure with <a href="/open-cell-spray-foam" className="text-blue-900 hover:text-blue-800 font-semibold underline">professional sealing technology</a>.
                  </p>
                </div>

                <div className="bg-gray-50 p-8 rounded-xl" style={{ width: '300px', flexShrink: 0 }}>
                  <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-6">
                    <i className="ri-volume-mute-line text-3xl text-blue-900"></i>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3"><strong>Sound Reduction</strong></h3>
                  <p className="text-gray-600 leading-relaxed">
                    Enjoy a quieter home with excellent soundproofing. Reduce outside noise and create peaceful living spaces for your family with <strong>spray foam insulation</strong>.
                  </p>
                </div>

                <div className="bg-gray-50 p-8 rounded-xl" style={{ width: '300px', flexShrink: 0 }}>
                  <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-6">
                    <i className="ri-time-line text-3xl text-blue-900"></i>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3"><strong>Fast Installation</strong></h3>
                  <p className="text-gray-600 leading-relaxed">
                    Most <strong>residential insulation projects</strong> completed in 1-2 days with minimal disruption. We work efficiently to get you back to normal quickly with professional results.
                  </p>
                </div>
              </div>
            </div>
            <div className="text-center text-sm text-gray-500 mt-2">
              Swipe to see more →
            </div>
          </div>

          {/* Desktop: Grid */}
          <div className="hidden md:grid md:grid-cols-3 gap-8">
            <div className="bg-gray-50 p-8 rounded-xl">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-6">
                <i className="ri-money-dollar-circle-line text-3xl text-blue-900"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3"><strong>Lower Energy Bills</strong></h3>
              <p className="text-gray-600 leading-relaxed">
                Reduce <strong>cooling costs by up to 50%</strong> in extreme desert heat. Most homeowners see immediate savings on their monthly utility bills with professional <strong>spray foam insulation</strong>.
              </p>
            </div>

            <div className="bg-gray-50 p-8 rounded-xl">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-6">
                <i className="ri-temp-cold-line text-3xl text-blue-900"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3"><strong>Year-Round Comfort</strong></h3>
              <p className="text-gray-600 leading-relaxed">
                Maintain consistent temperatures throughout your home. No more hot spots or cold drafts—just comfortable living spaces with superior <strong>thermal protection</strong> in any season.
              </p>
            </div>

            <div className="bg-gray-50 p-8 rounded-xl">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-6">
                <i className="ri-home-heart-line text-3xl text-blue-900"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3"><strong>Increased Home Value</strong></h3>
              <p className="text-gray-600 leading-relaxed">
                <strong>Energy-efficient homes</strong> sell faster and for more money. Professional <strong>insulation installation</strong> is a smart investment that pays dividends when you sell your property.
              </p>
            </div>

            <div className="bg-gray-50 p-8 rounded-xl">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-6">
                <i className="ri-shield-check-line text-3xl text-blue-900"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3"><strong>Moisture Protection</strong></h3>
              <p className="text-gray-600 leading-relaxed">
                Prevent mold, mildew, and water damage with our superior <strong>moisture barrier</strong>. Protect your family's health and your home's structure with <a href="/open-cell-spray-foam" className="text-blue-900 hover:text-blue-800 font-semibold underline">professional sealing technology</a>.
              </p>
            </div>

            <div className="bg-gray-50 p-8 rounded-xl">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-6">
                <i className="ri-volume-mute-line text-3xl text-blue-900"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3"><strong>Sound Reduction</strong></h3>
              <p className="text-gray-600 leading-relaxed">
                Enjoy a quieter home with excellent soundproofing. Reduce outside noise and create peaceful living spaces for your family with <strong>spray foam insulation</strong>.
              </p>
            </div>

            <div className="bg-gray-50 p-8 rounded-xl">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-6">
                <i className="ri-time-line text-3xl text-blue-900"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3"><strong>Fast Installation</strong></h3>
              <p className="text-gray-600 leading-relaxed">
                Most <strong>residential insulation projects</strong> completed in 1-2 days with minimal disruption. We work efficiently to get you back to normal quickly with professional results.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Our Simple <strong>Insulation Process</strong>
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              From consultation to completion, we make the entire <strong>spray foam insulation experience</strong> easy and stress-free for homeowners throughout Arizona.
            </p>
          </div>

          {/* Mobile: Horizontal Scroll */}
          <div className="md:hidden relative">
            <div className="overflow-x-auto pb-4 -mx-4 px-4 scrollbar-hide">
              <div className="flex gap-6" style={{ width: 'max-content' }}>
                <div className="text-center" style={{ width: '260px', flexShrink: 0 }}>
                  <div className="w-20 h-20 bg-blue-900 text-white rounded-full flex items-center justify-center mx-auto mb-6 text-3xl font-bold">
                    1
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3"><strong>Free Consultation</strong></h3>
                  <p className="text-gray-600">
                    Call us for a no-obligation <strong>home assessment</strong>. We'll evaluate your property and provide expert <a href="/about-yuma-insulation" className="text-blue-900 hover:text-blue-800 font-semibold underline">insulation recommendations</a> tailored to your needs.
                  </p>
                </div>

                <div className="text-center" style={{ width: '260px', flexShrink: 0 }}>
                  <div className="w-20 h-20 bg-blue-900 text-white rounded-full flex items-center justify-center mx-auto mb-6 text-3xl font-bold">
                    2
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3"><strong>Detailed Estimate</strong></h3>
                  <p className="text-gray-600">
                    Receive a transparent, itemized quote with no hidden fees. We explain every aspect of your <strong>insulation project</strong> clearly and answer all questions.
                  </p>
                </div>

                <div className="text-center" style={{ width: '260px', flexShrink: 0 }}>
                  <div className="w-20 h-20 bg-blue-900 text-white rounded-full flex items-center justify-center mx-auto mb-6 text-3xl font-bold">
                    3
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3"><strong>Professional Installation</strong></h3>
                  <p className="text-gray-600">
                    Our <strong>certified insulation team</strong> completes the work efficiently with minimal disruption to your daily routine. Quality workmanship guaranteed.
                  </p>
                </div>

                <div className="text-center" style={{ width: '260px', flexShrink: 0 }}>
                  <div className="w-20 h-20 bg-blue-900 text-white rounded-full flex items-center justify-center mx-auto mb-6 text-3xl font-bold">
                    4
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3"><strong>Quality Inspection</strong></h3>
                  <p className="text-gray-600">
                    Final walkthrough to ensure everything meets our high <strong>insulation standards</strong> and your complete satisfaction as a homeowner.
                  </p>
                </div>
              </div>
            </div>
            <div className="text-center text-sm text-gray-500 mt-2">
              Swipe to see more →
            </div>
          </div>

          {/* Desktop: Grid */}
          <div className="hidden md:grid md:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="w-20 h-20 bg-blue-900 text-white rounded-full flex items-center justify-center mx-auto mb-6 text-3xl font-bold">
                1
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3"><strong>Free Consultation</strong></h3>
              <p className="text-gray-600">
                Call us for a no-obligation <strong>home assessment</strong>. We'll evaluate your property and provide expert <a href="/about-yuma-insulation" className="text-blue-900 hover:text-blue-800 font-semibold underline">insulation recommendations</a> tailored to your needs.
              </p>
            </div>

            <div className="text-center">
              <div className="w-20 h-20 bg-blue-900 text-white rounded-full flex items-center justify-center mx-auto mb-6 text-3xl font-bold">
                2
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3"><strong>Detailed Estimate</strong></h3>
              <p className="text-gray-600">
                Receive a transparent, itemized quote with no hidden fees. We explain every aspect of your <strong>insulation project</strong> clearly and answer all questions.
              </p>
            </div>

            <div className="text-center">
              <div className="w-20 h-20 bg-blue-900 text-white rounded-full flex items-center justify-center mx-auto mb-6 text-3xl font-bold">
                3
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3"><strong>Professional Installation</strong></h3>
              <p className="text-gray-600">
                Our <strong>certified insulation team</strong> completes the work efficiently with minimal disruption to your daily routine. Quality workmanship guaranteed.
              </p>
            </div>

            <div className="text-center">
              <div className="w-20 h-20 bg-blue-900 text-white rounded-full flex items-center justify-center mx-auto mb-6 text-3xl font-bold">
                4
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3"><strong>Quality Inspection</strong></h3>
              <p className="text-gray-600">
                Final walkthrough to ensure everything meets our high <strong>insulation standards</strong> and your complete satisfaction as a homeowner.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Explore Our Services Section - REMOVED for optimal link density */}

      <CTA />
      <Footer />
    </div>
  );
}